/** Store URLs — keep in sync with public/join-links.config.json */
export const APP_STORE_URL = 'https://apps.apple.com/app/id6766300306';
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.draftland.app';
